import { useQuery } from "@tanstack/react-query";

import TenantAPI from "../api/api/TenantAPI";
import useModule from "./useModule";

// SUPPORTAL and MODULE TENANT - Get a module from a Tenant's Schema,
const useTenantModuleSupportal = ({
  supportTargetCloudID,
  moduleAPIName,
  isSupportal,
}: {
  supportTargetCloudID: string;
  moduleAPIName: string;
  isSupportal: boolean;
}) => {
  const { getModule } = useModule();
  const module = useQuery({
    queryKey: ["module", supportTargetCloudID, moduleAPIName],
    queryFn: async () => {
      if (!supportTargetCloudID || !moduleAPIName) return null;
      const cloud = await TenantAPI.getLatestSchema(supportTargetCloudID);

      const foundModule = cloud.CRM.Modules.find(
        (m: any) => m?.APIName === moduleAPIName
      );

      return foundModule;
    },
    enabled: isSupportal,
  });

  if (isSupportal) {
    return {
      module: module.data,
      isLoading: module.isLoading,
      error: module.error,
    };
  }

  return { module: getModule(moduleAPIName), isLoading: false, error: null };
};

export default useTenantModuleSupportal;
